<template>
  <div class="top-item">
    <img
      class="item-title"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/96ea0f357ec01dbdf6a876a7fb261219.png"
      alt=""
    />
    <div class="item-padding">
      <div class="item-day-info">
        <span class="day-left"
          >已连续签到
          <span class="red">{{ data.continuous_day }}</span> 天</span
        >
        <div class="day-right">
          <span class="day-tips">签到提醒</span>
          <van-switch
            v-model="openSignTips"
            active-color="#27CE5F"
            @change="bindChangeSignTips"
            :loading="disabledToggle"
            inactive-color="rgba(0,0,0,0.12)"
            size="18px"
          />
          <div
            class="sign-flag"
            :class="{ 'sign-flag-animate': showSignTips }"
            v-show="!openSignTips && showSignTips"
          >
            <div class="flag-text">开启提醒，永不错过！</div>
          </div>
        </div>
      </div>
      <div class="sign-list">
        <div
          class="sign-item"
          :class="{ 'sign-item-active': data.continuous_day > index }"
          v-for="(item, index) in data.sign_task"
          :key="index"
        >
          <img
            class="item-border-image"
            v-if="index == 6 && data.continuous_day < 7"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/728070a309d348054ac6f8a52069956c.webp"
            alt=""
          />
          <div
            class="sign-item-content"
            :class="{
              'sign-item-content-opacity': data.continuous_day <= index
            }"
          >
            <div class="item-day" v-if="data.continuous_day <= index"
              ><span class="iconfont icon-weijiesuo"></span>{{ item.name }}</div
            >
            <div class="signed" v-else
              ><span class="icon"><span class="iconfont icon-gou"></span></span
              ><span>已签到</span></div
            >
            <div class="prize-container">
              <div class="prize-list">
                <div
                  class="prize-item"
                  v-for="(item1, index1) in item.goods_list"
                  :key="index1"
                >
                  <div class="prize-item-container">
                    <div class="prize-name-c">
                      <div class="prize-name" v-html="item1.goods_name"></div>
                      <img class="prize-icon" :src="item1.icon" alt="" />
                    </div>
                  </div>
                  <div class="prize-num">x{{ item1.reward_num }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        class="sign-btn"
        v-if="!data.is_sign && data.continuous_day < data.sign_task.length"
        v-clickBuried
        data-click-buried="CLINK_XINRENHUODONG_QIANDAO"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/25ccfac78646172b47a99648257321c3.webp"
        @click="bindSign"
        alt=""
      />
      <div class="disabled-sign-btn" v-else>今日已签到</div>
    </div>
  </div>
</template>
<script>
import { Calendar } from '@/common/calendar.js'
import dataObj from '@/common/date.js'
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      disabledToggle: false,
      checked: false,
      openSignTips: false,
      showSignTips: false,
      calendarData: { calendarName: '7日签到赚积分' },
      hours: 10 //每天10点
    }
  },
  created() {
    this.init()
  },
  mounted() {
    setTimeout(() => {
      this.showSignTips = true
    }, 600)
  },
  methods: {
    bindSign() {
      this.$emit('sign')
    },
    //切换推送
    bindChangeSignTips() {
      if (this.openSignTips) {
        this.updateSignTips(this.data, this.hours, true)
      } else {
        this.Calendar.delCalendar()
          .then(() => {
            this.$toast('签到提醒已关闭')
          })
          .catch((e) => {
            this.$toast((e && e?.message) || '关闭失败')
            this.openSignTips = true
          })
      }
      this.disabledToggle = true
      setTimeout(() => {
        this.disabledToggle = false
      }, 2000)
    },
    setCalendarDays() {},
    init() {
      this.Calendar = new Calendar(this.calendarData)
      this.Calendar.haveCalendar(this.calendarData.calendarName)
        .then((res) => {
          this.openSignTips = res
          if (this.openSignTips) {
            this.updateSignTips(this.data, this.hours)
          }
        })
        .catch((e) => {
          this.openSignTips = false
        })
    },
    /* 每天更新用户的日历行程  */
    updateSignTips(signInfo, hours, isToast) {
      this.Calendar.delCalendar()
        .then((res) => {})
        .catch(() => {})
        .finally(() => {
          let addDay = signInfo.sign_task.length - signInfo.continuous_day
          let overDay = signInfo.is_sign
            ? signInfo.over_day
            : signInfo.over_day + 1
          addDay = addDay < overDay ? addDay : overDay
          let list = this.getTimeStrList(signInfo.is_sign, addDay, hours)
          this.Calendar.bindSetCalendar(list)
            .then(() => {
              isToast && this.$toast('签到提醒已开启')
            })
            .catch(() => {
              isToast && this.$toast('开启失败')
              this.openSignTips = false
            })
        })
    },
    /* 获取时间字符串列表*/
    getTimeStrList(isSign, addDay, hours) {
      let list = []
      let todayZeroTime = new Date(new Date().toLocaleDateString()).getTime()
      let calendarTime = todayZeroTime + hours * 1000 * 60 * 60
      let dayTime = 1000 * 60 * 60 * 24
      if (isSign) {
        calendarTime = calendarTime + dayTime
      }
      for (let i = 0; i < addDay; i++) {
        let curTime = calendarTime + i * dayTime
        list.push(dataObj.getFullTimeStr(curTime))
      }
      return list
    }
  }
}
</script>
<style lang="scss" scoped>
.item-padding {
  padding: 0px 16px 28px;
  background: #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.03);
  border-radius: 0px 0px 16px 16px;
}

.item-title {
  width: 100%;
}

.item-day-info {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;

  .day-left {
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 18px;

    .red {
      color: #ff4444;
    }
  }

  .day-right {
    position: relative;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.49);
    display: flex;
    align-items: center;

    .sign-flag {
      width: 0;
      height: 0;
      border-bottom: 0px solid transparent;
      border-top: 4px solid rgb(255, 93, 79);
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      position: absolute;
      left: 38%;
      bottom: 110%;
      .flag-text {
        padding: 2px 0px 0px 6px;
        font-size: 9px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        line-height: 16px;
        color: #ffffff;
        white-space: nowrap;
        left: 50%;
        bottom: 2px;
        transform: translate(-50%, 0%);
        position: absolute;
        height: 18px;
        border-radius: 9px;
        background: linear-gradient(90deg, #ff9441 0%, #ff4c53 100%), #ff4c53;
      }
    }
    .sign-flag-animate {
      animation: myOpacity 1s linear;
    }
    .day-tips {
      margin-right: 3px;
    }

    ::v-deep .van-switch {
      width: 31px;
      border: none;

      .van-switch__node {
        width: 0.77em;
        height: 0.77em;
        left: 2px;
        top: 2px;
      }
    }

    ::v-deep .van-switch--on {
      .van-switch__node {
        transform: translateX(0.7em);
      }
    }
  }
}

.sign-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;

  .sign-item {
    width: 75px;
    height: 100px;
    margin-right: 5px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
    position: relative;
    .sign-item-content {
      background: linear-gradient(180deg, #ffefd6 0%, #feddc4 100%);
      border-radius: 8px;
      height: 100%;
      padding: 7px 7px 13px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: relative;
    }
    .sign-item-content-opacity {
      opacity: 0.8;
    }
    .signed {
      position: relative;
      z-index: 1;
      color: #fff;
      font-size: 11px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        width: 10px;
        height: 10px;
        background: #ffffff;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 2px;

        .iconfont {
          color: #fe6b73;
          font-size: 12px;
          transform: scale(0.6);
        }
      }
    }

    .item-day {
      position: relative;
      z-index: 1;
      font-size: 11px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: rgba(139, 55, 22, 0.8);
      line-height: 12px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon-weijiesuo {
        font-size: 10px;
        color: rgba(162, 91, 60, 1);
        margin-right: 2px;
      }
    }

    .prize-container {
      flex: 1;
      flex-shrink: 0;
      display: flex;
      align-items: flex-end;
      justify-content: center;

      .prize-list {
        display: flex;
        align-items: stretch;
        justify-content: center;

        .prize-item {
          display: flex;
          flex-direction: column;
        }

        .prize-item-container {
          flex: 1;
          flex-shrink: 0;
          overflow: visible;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .prize-item {
        margin-right: 5px;

        .prize-name-c {
          position: relative;

          .prize-name {
            position: relative;
            z-index: 1;
            min-height: 10px;
            padding: 3px 2px 1px;
            min-width: 25px;
            box-sizing: border-box;
            text-align: center;
            background: #ffffff;
            border-radius: 7px;
            font-size: 9px;
            font-family: MiSans, MiSans;
            font-weight: 600;
            color: rgba(139, 55, 22, 0.8);
            line-height: 10px;
          }

          .prize-icon {
            z-index: 0;
            position: absolute;
            left: 50%;
            bottom: calc(100% - 4px);
            width: 90%;
            transform: translate(-50%, 0%);
          }
        }

        .prize-num {
          text-align: center;
          font-size: 13px;
          line-height: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #ff4444;
        }
      }

      .prize-item:last-child {
        margin-right: 0;
      }
    }
  }

  .sign-item:nth-child(4n) {
    margin-right: 0px;
  }

  .sign-item:last-child {
    box-sizing: border-box;
    margin-right: 0;
    width: 155px;
    height: 100px;
    box-shadow: 0px 3px 9px 0px rgba(253, 54, 69, 0.3);
  }

  .item-border-image {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .sign-item-active {
    .sign-item-content {
      background: linear-gradient(180deg, #ffa07e 0%, #fe6b73 100%);
      box-shadow: 0px 3px 9px 0px rgba(253, 54, 69, 0.24);
    }
    .prize-list {
      .prize-item {
        .prize-num {
          color: #fff;
        }
      }
    }
  }
}

.sign-btn {
  margin: 0 auto;
  width: 268px;
  height: 48px;
  box-shadow: 0px 5px 12px 0px rgba(253, 54, 69, 0.3),
    inset 0px -6px 7px 0px #ff6985;
  border-radius: 24px;
  animation: scaleAnimate 1.6s linear infinite;
}

.disabled-sign-btn {
  text-align: center;
  margin: 0 auto;
  width: 268px;
  height: 48px;
  background: #cccccc;
  border-radius: 26px;
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 48px;
}

@keyframes scaleAnimate {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.05);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}
@keyframes myOpacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
